export default {
	propose: 'Stwórz własne wydarzenie i sprzedaj bilety online za pomocą usług teeko!',
	description: 'Niezrównane doświadczenie zaczyna się od zakupu biletu!',
	moreEvents: 'Pokaż więcej wydarzeń',
	search: 'Szukaj'
}
